var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-list" },
    [
      _c("actionBarComponent", {
        attrs: {
          title: _vm.$t("__.Crud.inventario.edit_vue_html.ajusteEstq"),
          showSave: false,
        },
      }),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { novalidate: "novalidate" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              _vm.save()
            },
          },
        },
        [
          !_vm.finalizado
            ? _c("fieldset", [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-3" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first("tipoInventarioId"),
                            expression: "errors.first('tipoInventarioId')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: {
                              for: "tipoInventario",
                              title: _vm.$t("__.obrigatorio"),
                            },
                          },
                          [
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v("*"),
                            ]),
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.inventario.edit_vue_html.tipoInvent"
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("combo-component", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          attrs: {
                            id: "tipoInventario",
                            name: "tipoInventario",
                            data: _vm.tipoInventarioOptions,
                            searchable: true,
                            disabled: _vm.desabilita,
                          },
                          model: {
                            value: _vm.model.tipoInventario,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "tipoInventario", $$v)
                            },
                            expression: "model.tipoInventario",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.model.tipoInventario == 1
                    ? _c("div", { staticClass: "col-sm-4" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.errors.first("grupoProduto"),
                                expression: "errors.first('grupoProduto')",
                              },
                            ],
                            staticClass: "form-group",
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: {
                                  for: "GrupoProduto",
                                  title: _vm.$t("__.obrigatorio"),
                                },
                              },
                              [
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.inventario.edit_vue_html.grupoProd"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("combo-component", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              attrs: {
                                id: "grupoProduto",
                                name: "grupoProduto",
                                data: _vm.produtoGrupoOptions,
                                searchable: true,
                                disabled: _vm.desabilita,
                              },
                              model: {
                                value: _vm.model.grupoInventarioId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "grupoInventarioId", $$v)
                                },
                                expression: "model.grupoInventarioId",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !this.modelId
                    ? _c("div", { staticClass: "col-sm-2" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.errors.first("ativo"),
                                expression: "errors.first('ativo')",
                              },
                            ],
                            staticClass: "form-group",
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "control-label",
                                attrs: { for: "ativo" },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$t(
                                        "__.Crud.inventario.edit_vue_html.ignoraLotesZerados"
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("checkbox-component", {
                              attrs: {
                                id: "ignorarLotesZerados",
                                name: "ignorarLotesZerados",
                              },
                              model: {
                                value: _vm.ignorarLotesZerados,
                                callback: function ($$v) {
                                  _vm.ignorarLotesZerados = $$v
                                },
                                expression: "ignorarLotesZerados",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-3" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first("estoque"),
                            expression: "errors.first('estoque')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: {
                              for: "estoque",
                              title: _vm.$t("__.obrigatorio"),
                            },
                          },
                          [
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v("*"),
                            ]),
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t(
                                    "__.Components.parent.home.fastaction.fastaction_vue_html.estoque"
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("combo-component", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          attrs: {
                            id: "estoque",
                            name: "estoque",
                            data: _vm.estoqueOptions,
                            disabled: _vm.inventarioIniciado,
                          },
                          model: {
                            value: _vm.model.estoqueId,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "estoqueId", $$v)
                            },
                            expression: "model.estoqueId",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.finalizado
            ? _c(
                "div",
                [
                  _c(
                    "fieldset-component",
                    {
                      attrs: {
                        title: _vm.$t(
                          "__.Crud.inventario.edit_vue_html.ajusteEstq"
                        ),
                        collapsed: _vm.colapsed,
                      },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "rows" }, slot: "rows" },
                        [
                          _c(
                            "grid-component",
                            {
                              attrs: {
                                columns: _vm.produtoGridDataColumns,
                                conditionShowSubData: _vm.conditionShowSubData,
                                data: _vm.produtosFiltrados,
                                extendedColStartOpen: false,
                                extraSubActions: _vm.extraSubActions,
                                "show-sort-icons": true,
                                "show-table-head": true,
                                showActionColumn: true,
                                showAddNewButton: false,
                                showEditItem: false,
                                showExpand: true,
                                showRemoveItem: false,
                                showTools: false,
                                subColumns: _vm.loteGridDataColumns,
                                subDataName: "itens",
                              },
                              on: {
                                "extra-sub-action": _vm.onExtraSubAction,
                                "change-filter-key": _vm.onFiltrar,
                                "change-sort": _vm.onChangeSort,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "grid-footer",
                                  attrs: { slot: "footer" },
                                  slot: "footer",
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.inventario.edit_vue_html.produtos"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(_vm._s(_vm.totalProdutos)),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "info-panel" }, [
                      _c("h4", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("__.Crud.inventario.edit_vue_html.status")
                          ) +
                            " " +
                            _vm._s(_vm.statusInventario)
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "grid-component",
                    {
                      ref: "gridcomponent",
                      attrs: {
                        columns: _vm.produtoFinalizadoGridColumns,
                        conditionShowSubData:
                          _vm.conditionMovimentacaoShowSubData,
                        data: _vm.produtosMovimentacaoFiltrados,
                        extendedColStartOpen: true,
                        "show-export-pdf": false,
                        "show-export-xls": false,
                        "show-sort-icons": false,
                        "show-table-head": true,
                        showActionColumn: false,
                        showAddNewButton: false,
                        showEditItem: false,
                        showExpand: true,
                        showRemoveItem: false,
                        subColumns: _vm.loteFinalizadoGridColumns,
                        subDataName: "itens",
                        tituloPagina: "Movimentos",
                        total: _vm.total,
                      },
                      on: {
                        "change-filter-key": _vm.onFiltrarConcluidos,
                        ":gerar-impressao": function ($event) {
                          _vm.pags = true
                          _vm.tipoDocGerar = 2
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "grid-footer",
                          attrs: { slot: "footer" },
                          slot: "footer",
                        },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "__.Crud.inventario.edit_vue_html.movimentacoes"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [_vm._v(_vm._s(_vm.totalMovimentacoes))]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
          _vm._v(" "),
          _c("fieldset", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12 newbtn" }, [
                _c("div", { staticClass: "form-group" }, [
                  !_vm.iniciado && !_vm.consulta
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          attrs: { type: "button" },
                          on: { click: _vm.onIniciar },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-check",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(
                                  "__.Crud.inventario.edit_vue_html.iniciar"
                                )
                              ) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _vm.iniciado && !_vm.consulta
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          attrs: { type: "button" },
                          on: { click: _vm.onFinalizar },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-check",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(
                                  "__.Crud.inventario.edit_vue_html.finalizar"
                                )
                              ) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.iniciado && !_vm.consulta
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-danger",
                          attrs: { type: "button" },
                          on: { click: _vm.onCancelar },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("__.Crud.cancelar")) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.cancel },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("__.Crud.voltar")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }